import { render, staticRenderFns } from "./hints.vue?vue&type=template&id=7092b0a1&scoped=true"
import script from "./hints.vue?vue&type=script&lang=ts"
export * from "./hints.vue?vue&type=script&lang=ts"
import style0 from "./hints.vue?vue&type=style&index=0&id=7092b0a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7092b0a1",
  null
  
)

export default component.exports